import React from 'react'
import { List, ListItem, ListItemText, Divider } from '@mui/material'
import { Font } from '@pepsico-ds/ui'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'

function HeaderNotifications({ notificationCount, notifications }) {
  // Calculate maxHeight: show 4 items max, then scroll
  // Each item is approximately 70px (with padding and divider)
  const maxVisibleItems = 4
  const itemHeight = 70
  const shouldScroll = notifications?.length > maxVisibleItems
  const maxHeight = shouldScroll ? `${maxVisibleItems * itemHeight}px` : undefined

  return (
    <>
      <span
        style={{
          position: 'absolute',
          top: '-12px',
          right: '46px',
          width: 0,
          height: 0,
          borderLeft: '10px solid #c0bebe0d',
          borderRight: '10px solid #c0bebe0d',
          borderBottom: '15px solid white',
        }}
      />
      <List
        sx={{
          width: '300px',
          ...(maxHeight && { maxHeight }),
          overflowY: shouldScroll ? 'auto' : 'visible',
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
          zIndex: 1300,
        }}
      >
        {notifications?.length === 0 ? (
          <ListItem>
            <ListItemText primary="No notifications" />
          </ListItem>
        ) : (
          notifications?.map((notification, index) => (
            <React.Fragment key={notification?.notificationId || index}>
              <ListItem sx={{ alignItems: 'flex-start', padding: '8px 16px' }}>
                <FiberManualRecordIcon
                  sx={{
                    color: '#005cbc',
                    fontSize: 10,
                    marginRight: 2,
                    marginTop: '12px',
                    flexShrink: 0,
                  }}
                />
                <ListItemText
                  sx={{ maxWidth: '220px', overflow: 'hidden' }}
                  primary={
                    <Font
                      variant="bold"
                      size="small"
                      style={{
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '100%',
                        lineHeight: '1.4',
                      }}
                    >
                      {notification?.message}
                    </Font>
                  }
                />
              </ListItem>

              {index < notifications.length - 1 && <Divider />}
            </React.Fragment>
          ))
        )}
      </List>
    </>
  )
}

export default HeaderNotifications
